import { isResolvedFlightJourneyId } from 'tripPlanner/pages/chat/ChatTripPlannerPage/utils/flightCartPanelUtils'
import { getTotalStopCount } from 'lib/flights/flightUtils'

/**
 * Renders the per-journey context block sent to the assistant when a flight is
 * added to the trip. Shared by the flight search drawer and the chat flight
 * recommendation cards so the context format stays single-sourced.
 */
export function buildFlightContext(journey: App.JourneyV2): string {
  const jFlights = journey.flightGroup.flights
  const firstFlight = jFlights[0]
  const lastFlight = jFlights[jFlights.length - 1]
  const duration = journey.flightGroup.totalFlightDuration
  const lines = [
    `Carrier: ${journey.carrierName}`,
    `Flight: ${jFlights.map(f => f.flightNumber).filter(Boolean).join(' / ')}`,
    `From: ${firstFlight.departureAirport} (${firstFlight.departureAirportName})`,
    `To: ${lastFlight.arrivalAirport} (${lastFlight.arrivalAirportName})`,
    `Departure: ${firstFlight.departureDateTime}`,
    `Arrival: ${lastFlight.arrivalDateTime}`,
    `Duration: ${duration.hours}h ${duration.minutes}m`,
    `Stops: ${getTotalStopCount(jFlights)}`,
    `Price: ${journey.currencyCode} ${journey.price.adult.totalFare}`,
    `Fare type: ${journey.fareType}`,
    `Carrier logo: ${journey.carrierBrandMark ?? journey.carrierLogo}`,
  ]
  if (journey.bookingInfo?.journeyKey) lines.push(`Journey Key: ${journey.bookingInfo.journeyKey}`)
  if (isResolvedFlightJourneyId(journey.id, journey.bookingInfo?.journeyKey)) lines.push(`Journey ID: ${journey.id}`)
  if (journey.bookingInfo?.providerSearchId) lines.push(`Search ID: ${journey.bookingInfo.providerSearchId}`)
  return lines.join('\n')
}
